import styled from 'styled-components'

import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

export const Content = styled.div`
  width: 100%;
  margin-top: 24px;
  padding: 0 16px;

  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 768px) {
    padding: 0 100px;

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto;
    gap: 48px;
  }
`

export const ButtonsContainer = styled.div`
  width: 100%;

  margin-top: 48px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;

  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.gray900};

  background: transparent;

  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
  }
`

export const Input = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 16px;

  border: 1px solid ${theme.colors.gray300};
  border-radius: 4px;

  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.gray900};
`

export const SpanInfo = styled.span`
  font-size: 12px;
  color: ${theme.colors.gray500};
`

export const SaveButton = styled.button`
  padding: 12px 8px;

  border: none;
  border-radius: 4px;

  margin: 0 auto;

  font-size: ${theme.font.sizes.small};
  color: ${theme.colors.white};
  font-weight: ${theme.font.bold};

  background: ${theme.colors.green1};

  cursor: pointer;

  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`

export const Text = styled.div`
  font-size: ${theme.font.sizes.normal};
  color: ${theme.colors.gray900};

  width: 100%;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  white-space: pre-line;

  @media (min-width: 768px) {
    width: 300px;
  }
`
